import React from "react";
import { useTranslation } from "react-i18next";
import { styled } from "goober";

import { TRAIT_NAMES_FIX } from "@/game-tft/constants.mjs";
import { colorFromCount } from "@/game-tft/get-color-from-count.mjs";
import { styleToColor } from "@/game-tft/get-style-to-color.mjs";
import StaticTFT from "@/game-tft/static.mjs";
import TypeIcon from "@/game-tft/TypeIcon.jsx";
import { useTraits } from "@/game-tft/use-traits.mjs";

const TraitBox = styled("div")`
  display: flex;
  align-items: center;
  > * {
    pointer-events: none;
  }
  &:last-of-type {
    margin-right: 0;
  }
`;
const TraitCount = styled("div")`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: var(--sp-4);
  height: 15px;
  width: 15px;
  font-size: var(--sp-2_5);
  font-weight: 700;
  color: var(--shade0);
  background: var(--shade5);
  border-radius: var(--br-sm);
`;

const TraitCounter = ({
  traitName,
  set,
  iconSize,
  count,
  depthColors,
  noNumber = true,
  traitStyle,
  ...restProps
}) => {
  const { t } = useTranslation();
  const traits = useTraits("params", set);
  const key = TRAIT_NAMES_FIX[set]?.[traitName]?.toLowerCase() || traitName;
  const trait = traits[key];
  if (!trait) return null;
  return (
    <TraitBox
      {...restProps}
      data-place="bottom"
      data-tip={`${t(`tft:traits.${trait.key?.toLowerCase()}`, trait.name)}`}
    >
      {depthColors ? (
        <TypeIcon
          name={StaticTFT.getTraitKey(trait.apiKey, set)}
          size={iconSize}
          traitMetColor={
            typeof traitStyle === "number"
              ? styleToColor(traitStyle)
              : colorFromCount(key, count, trait)
          }
        />
      ) : (
        <TypeIcon set={set} name={trait.key} size={iconSize} />
      )}
      {!noNumber && (
        <TraitCount
          style={
            iconSize && {
              height: `${iconSize * 0.75}px`,
              width: `${iconSize * 0.75}px`,
              fontSize: `${iconSize * 0.5}px`,
            }
          }
        >
          {count}
        </TraitCount>
      )}
    </TraitBox>
  );
};

export default TraitCounter;
